import React, { FC, useEffect, useMemo, useState } from 'react';
import { getWorkOrderTotalPartsCost } from '../../thunks/parts_equipments_work_orders_thunks';
import { withRouter } from 'react-router';
import { message } from 'antd';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { renderCurrency } from '../../utils/DataAccessUtils';

const WOPartsTotalCost: FC<any> = ({ fetchCost, currentUser, match }): React.ReactElement => {
	const [costLoading, setCostLoading] = useState(true);
	const [totalCost, setTotalCost] = useState(0);

	const workOrderId = useMemo(() => match.params.id, [match.params.id]);

	useEffect(() => {
		fetchCost(workOrderId)
			.then(setTotalCost)
			.catch(message.error)
			.finally(() => setCostLoading(false));
	}, []);

	return (
		<AccessPermissionChecker name={PERMISSION_NAMES.CAN_VIEW_PART_EQUIPMENT_COST_IN_WO}>
			{!costLoading ? (
				<div className="mr-2">{`Total Cost: ${renderCurrency(currentUser)(totalCost)}`}</div>
			) : null}
		</AccessPermissionChecker>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	fetchCost: (workOrderId) =>
		dispatch(getWorkOrderTotalPartsCost(ROLE_TYPES.SUPPLIER)(workOrderId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WOPartsTotalCost));
